import classNames from "classnames";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { SMALL_WHITE_CHAT_ICON } from "../utils/svgs_new";
import IconWithBadge from "./IconWithBadge/IconWithBadge";

interface Props {
  badge: number;
  isPopperOpen: boolean;
  onClick: () => void;
}

const OnboardingChatIcon = (props: Props) => {
  return (
    <div className="VisitChatIcon">
      <IconWithBadge
        icon={SMALL_WHITE_CHAT_ICON}
        badge={props.badge}
        onClick={props.onClick}
        size={16}
      />
      <div className={classNames("__popper", { active: props.isPopperOpen })}>
        {translate(STRINGS.HAVE_A_QUESTION_LETS_CHAT)}
      </div>
    </div>
  );
};

export default OnboardingChatIcon;
